import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { Orgao } from 'src/app/shared/models/orgao.model';
import { Usuario } from 'src/app/shared/models/usuario.model';
import { OrgaoSetorialista } from '../../models/orgao-setorialista.model';
import { OrgaoSetorialistaService } from '../../services/orgao-setorialista.service';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-orgao-setorialista-edit',
  templateUrl: './orgao-setorialista-edit.component.html',
  styleUrls: ['./orgao-setorialista-edit.component.scss']
})
export class OrgaoSetorialistaEditComponent extends BaseFormComponent<OrgaoSetorialista> implements OnInit {

  actionLabel: string = 'Novo';
  orgaoList: Orgao[];
  usuarioList: Usuario[];

  constructor(
    private myService: OrgaoSetorialistaService,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.orgaoList = this.activatedRoute.snapshot.data["listOrgao"];
    this.usuarioList = this.activatedRoute.snapshot.data["listusuario"];
    this.loaded();
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      agency_id: new FormControl('', [Validators.required]),
      user_cpf: new FormControl('', [Validators.required]),
    });

    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.get('user_cpf').setValue(String(this.entity?.user_cpf));
      this.form.get('agency_id').setValue(this.entity?.agency_id);
    }
  }

  voltar() {
    this.navigation.back(['projetos/admin-spgg/orgao-setorialista']);
  }

  getDataCreate(): OrgaoSetorialista {
    let data: OrgaoSetorialista;
    data = Object.assign({}, data, this.form.value);
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id) {
        this.addSub(
          this.myService.update(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res: OrgaoSetorialista) => {
              this.msgSuccess('Cadastro alterado com sucesso!');
              this.loaded();
            },
            error: (error) => {
              if (error.status === 409) {
                this.msgError(error?.error?.message)
              }
              this.loaded();
            },
          })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res: OrgaoSetorialista) => {
              this.msgSuccess('Cadastro criado com sucesso!');
              this.navigation.replace(['projetos/admin-spgg/orgao-setorialista/', res.id]);
              this.loaded();
            },
            error: (error) => {
              if (error.status === 409) {
                this.msgError(error?.error?.message)
              }
              this.loaded();
            },
          })
        );
      }
    }
    else {
      this.markAsDirty();
    }
  }
}
